import React from "react";
import { createPortal } from "react-dom";

const Portal = ({ children }: { children: React.ReactNode }) => {
  return createPortal(children, document.getElementById("modal-root")!);
};

export default Portal;
